const isDeltaCol = (compareSort: MatrixCompareSortType): boolean => {
  return [
    'delta asc',
    'delta desc',
    'abs delta asc',
    'abs delta desc',
  ].includes(compareSort);
};

export default isDeltaCol;
